import React from 'react';
import Layout, { MainContent } from '@layout';
import Breadcrumbs from '@components/Breadcrumbs';
import RawHTML from '@components/RawHTML';
import { H1 } from '@heading';
import usePageContext from '@hooks/usePageContext';
import styles from './Layout.module.scss';
import classNames from 'classnames';

export default function InnerLayout({
  title,
  h1: _h1,
  children,
  data,
  contentClassName,
  headerContent,
  rightAlignDots = true,
  showDots,
  breadcrumbs,
  currentPageLabel,
  showBreadcrumbs = true,
  contentTag = 'div',
  maxWidth,
  ...restProps
}) {
  const context = usePageContext();
  const h1 = _h1 ?? context.h1 ?? title ?? context.title;

  return (
    <Layout
      title={title ?? context.title ?? h1}
      {...restProps}
    >
      <MainContent
        contentClassName={classNames(
          styles.innerWrapper,
          contentClassName
        )}
        rightAlignDots={rightAlignDots}
        showDots={showDots}
        tag={contentTag}
        maxWidth={maxWidth}
      >
        {headerContent}
        {h1 && <H1>{h1}</H1>}
        {showBreadcrumbs && (
          <Breadcrumbs
            crumbs={breadcrumbs}
            currentPageLabel={currentPageLabel}
          />
        )}
        <div className="page-content">
          {children}
          <RawHTML>{data?.markdownRemark?.html}</RawHTML>
        </div>
      </MainContent>
    </Layout>
  );
}
